"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * execute and FIR filter. Based on ARM implementation
 *
 * @param  {number[]} data - data to filter
 * @param  {number[]} coeffs - coefficents of the filter to apply to the data
 * @returns number[]
 */
function fir_filter(data, coeffs) {
    var acc;
    var results = []; // Array.apply(undefined, Array(data.length)).map(i => {return 0.0});
    var numTaps = coeffs.length;
    for (var n = (numTaps - 1); n < data.length; n++) {
        acc = 0.0;
        for (var i = 0; i < numTaps; i++) {
            var dataIndex = n - (numTaps - 1 - i);
            var coeffsIndex = i;
            acc += data[dataIndex] * coeffs[coeffsIndex];
        }
        results.push(acc);
    }
    for (var i = numTaps - 1; i > 0; i--) {
        var acc_1 = 0.0;
        for (var j = 0; j < numTaps - i; j++) {
            acc_1 += data[i] * coeffs[(numTaps - 1) - j];
        }
        results.unshift(acc_1);
    }
    return results;
}
exports.fir_filter = fir_filter;
